import {Service} from "@/services/superclasses/service";
import {FormResponse} from "@/interfaces/form-response";
import {PendingSubscriberData} from "@/interfaces/pending-subscriber-data";

const api = window.contextPath + '/rest/payments';

export class PaymentService extends Service {
    public supportBordas = async (productId: number): Promise<boolean> => {
        return this.data(await this.get<boolean>(api + "/support-bordas",
            {
                params: {
                    productId
                }
            }
        ))
    };

    public getCheckoutLanguage = async (): Promise<string> => {
        return this.data(await this.get<string>(api + "/checkout-language"))
    };

    public getCheckoutKey = async (): Promise<string> => {
        return this.data(await this.get<string>(api + "/checkoutkey"))
    };

    public getProductGroups = async (productType: string, campaignId?: number): Promise<string> => {
        return this.data(await this.get<string>(api + "/product-groups",
            {
                params: {
                    productType,
                    campaignId
                }
            }))
    };

    public validateOrder = async (data: PendingSubscriberData): Promise<FormResponse<string>> => {
        return this.data(await this.post<FormResponse<string>>(api + "/validate-order", data))
    }

    public handlePayment = async (data: PendingSubscriberData): Promise<FormResponse<string>> => {
        return this.data(await this.post<FormResponse<string>>(api + "/handle-payment", data))
    }

    public setSubscription = async (paymentId: string): Promise<FormResponse<string>> => {
        return this.data(await this.post<FormResponse<string>>(api + "/update-subscription", {
            paymentId
        }, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }))
    }

    public renewCard = async (subscriptionId: string, paymentId: string): Promise<FormResponse<string>> => {
        return this.data(await this.post<FormResponse<string>>(api + "/renew-card", {
            subscriptionId,
            paymentId
        }, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }))
    }

}

export const paymentService = new PaymentService()